import { render, staticRenderFns } from "./u-footer-head-basic.vue?vue&type=template&id=ea6d77f4&scoped=true"
import script from "./u-footer-head-basic.vue?vue&type=script&lang=js"
export * from "./u-footer-head-basic.vue?vue&type=script&lang=js"
import style0 from "./u-footer-head-basic.vue?vue&type=style&index=0&id=ea6d77f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6d77f4",
  null
  
)

export default component.exports